import { render, staticRenderFns } from "./ProlificMainStudy.vue?vue&type=template&id=2a95fef6"
import script from "./ProlificMainStudy.vue?vue&type=script&lang=js"
export * from "./ProlificMainStudy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports